export const URGENCY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'critical', label: 'Critical' },
];

export const AUDIENCE_OPTIONS = [
  { value: 'all_users', label: 'All Users' },
  { value: 'new_users', label: 'New Users' },
  { value: 'premium_users', label: 'Premium Users' },
  { value: 'inactive_users', label: 'Inactive Users' },
  { value: 'VA', label: 'VA' },
  { value: 'custom', label: 'Custom Segment' },
];

export const PLATFORM_OPTIONS = [
  { value: 'ios', label: 'iOS', icon: 'apple', disabled: true },
  { value: 'android', label: 'Android', icon: 'android', disabled: true },
  { value: 'web', label: 'Web', icon: 'globe' },
];

export const TAB_OPTIONS = [
  { value: 'all', label: 'All', count: 247 },
  { value: 'active', label: 'Active', count: 12 },
  { value: 'scheduled', label: 'Scheduled', count: 8 },
  { value: 'expired', label: 'Expired', count: 215 },
  { value: 'drafts', label: 'Drafts', count: 12 },
];

export const DEFAULT_FORM_DATA = {
  title: '',
  notificationMessage: '',
  targetAudience: 'all_users',
  urgency: 'low',
  platforms: ['web'],
  duration: 0,
  isScheduled: false,
  scheduledDate: '',
  scheduledTime: '',
};

export const MAX_MESSAGE_LENGTH = 280;

export const URGENCY_STYLES = {
  low: 'bg-sky-100 border-sky-400 text-sky-700',
  normal: 'bg-green-100 border-green-500 text-green-700',
  high: 'bg-amber-100 border-amber-500 text-amber-700',
  critical: 'bg-red-100 border-red-400 text-red-700',
};

export const URGENCY_BADGE_STYLES = {
  low: 'bg-sky-100 text-sky-700',
  normal: 'bg-green-100 text-green-700',
  high: 'bg-amber-100 text-amber-700',
  critical: 'bg-red-100 text-red-700',
};

export const STATUS_STYLES = {
  active: 'bg-green-100 text-green-700',
  scheduled: 'bg-purple-100 text-purple-600',
  expired: 'bg-gray-100 text-gray-500',
  draft: 'bg-amber-100 text-amber-700',
};
